import { render, staticRenderFns } from "./RatingsView.vue?vue&type=template&id=31a6a1cb&scoped=true"
import script from "./RatingsView.vue?vue&type=script&lang=js"
export * from "./RatingsView.vue?vue&type=script&lang=js"
import style0 from "./RatingsView.vue?vue&type=style&index=0&id=31a6a1cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6a1cb",
  null
  
)

export default component.exports